import axios from "axios";
import React, { useState } from "react";

export const VoiceContext = React.createContext({});

const VoicePlayerContextProvider = ({ children }) => {
  const [playlist, setPlaylist] = useState({});
  const [playbackRate, setPlaybackRate] = useState(
    +localStorage.getItem("playbackRate") || 1
  );

  const play = (id, url) => {
    if (playlist[id]) {
      if (playlist[id].status === "loading") {
        return;
      } else if (playlist[id].status === "playing") {
        updatePlaylist(id, { status: "paused" });
        playlist[id].element.pause();
        return;
      } else {
        updatePlaylist(id, { status: "playing" });
        pauseAll(id);
        playlist[id].element.playbackRate = playbackRate;
        playlist[id].element.play();
      }
    } else {
      setPlaylist((pre) => ({ ...pre, [id]: { status: "loading" } }));
      axios
        .get(url, { responseType: "blob" })
        .then((res) => {
          const src = URL.createObjectURL(res.data);
          const audio = new Audio(src);

          audio.oncanplaythrough = () => {
            pauseAll(id);
            audio.playbackRate = playbackRate;
            audio.play();
            updatePlaylist(id, {
              duration: audio.duration,
              status: "playing",
              element: audio,
            });
            audio.oncanplaythrough = undefined;
          };

          audio.ontimeupdate = () => {
            updatePlaylist(id, { currentTime: audio.currentTime });
          };

          audio.onended = () => {
            updatePlaylist(id, { status: "paused" });
          };

          audio.play();
        })
        .catch(() => {
          setPlaylist((pre) => {
            const playlist = { ...pre };
            delete playlist[id];
            return playlist;
          });
        });
    }
  };

  const updatePlaylist = (id, value) => {
    setPlaylist((pre) => ({ ...pre, [id]: { ...pre[id], ...value } }));
  };

  const seekTo = (value, element) => {
    if (element) {
      element.currentTime = (value / 100) * element.duration;
    }
  };

  const pauseAll = (ignore) => {
    setPlaylist((pre) => {
      const playlist = { ...pre };
      Object.keys(playlist).forEach((id) => {
        if (playlist[id].status === "playing" && id !== ignore) {
          playlist[id].status = "paused";
          playlist[id].element.pause();
        }
      });
      return pre;
    });
  };

  const changePlaybackRate = () => {
    const rate = playbackRate < 1.5 ? 1.5 : playbackRate < 2 ? 2 : 1;
    localStorage.setItem("playbackRate", rate);
    setPlaybackRate(rate);
    Object.values(playlist)
      .filter((item) => item.status === "playing")
      .forEach((item) => {
        item.element.playbackRate = rate;
      });
  };

  return (
    <VoiceContext.Provider
      value={{ play, playlist, seekTo, playbackRate, changePlaybackRate }}
    >
      {children}
    </VoiceContext.Provider>
  );
};

export default VoicePlayerContextProvider;
